import { BridgeActorsStatus } from '@/types/home';
import { useFm } from '@web3/base-hooks';

import styles from './index.module.scss';

export interface IProps {
  status: BridgeActorsStatus;
}

export const BridgeStatusTag = (props: IProps) => {
  const { status } = props;
  const fm = useFm();
  const config = {
    [BridgeActorsStatus.ON_TRACKING]: {
      color: '#20B26C',
      bgColor: 'rgba(32, 178, 108, 0.16)',
      text: fm('tracking'),
    },
    [BridgeActorsStatus.NO_RESPOND]: {
      color: '#EF454A',
      bgColor: 'rgba(239, 69, 74, 0.16)',
      text: fm('noResponse'),
    },
    [BridgeActorsStatus.REFUSED_RESPOND]: {
      color: '#EF454A',
      bgColor: 'rgba(239, 69, 74, 0.16)',
      text: fm('rejectSupport'),
    },
    [BridgeActorsStatus.IN_COMMUNICATION]: {
      color: '#20B26C',
      bgColor: 'rgba(32, 178, 108, 0.16)',
      text: fm('inCommunication'),
    },
  };

  if (!config[status]) return '--';

  return (
    <div
      className={styles.status}
      style={{
        color: config[status]?.color ?? '#EF454A',
        backgroundColor: config[status]?.bgColor ?? 'rgba(32, 178, 108, 0.16)',
      }}
    >
      {config[status]?.text ?? '--'}
    </div>
  );
};
